import React, {useEffect,useState} from 'react';
import {Link} from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { TextField } from '@mui/material';
  
import { collection, query, where, getDocs} from 'firebase/firestore';
import { db } from '../../firebase';
import AdminNavbar from '../../components/AdminNavbar';

const customerSearchQuery = (field, searchInput) => query(
  collection(db, 'users'), 
  where(field, '>=', searchInput), 
  where(field, '<=', searchInput + '\uf8ff'), 
)

export default function DynamicTable() {
    // const [users, setUsers] = useState([]);
    const [searchInput, setSearchInput] = useState('')
    const [filteredUsers, setFilteredUsers] = useState([])
    
    // filter users by search input
    useEffect(() => {
      
      if(searchInput.length < 3) return;
      // search users collection by first name, last name, email, mobile
      Promise.all([
        getDocs(customerSearchQuery('firstName', searchInput)),
        getDocs(customerSearchQuery('lastName', searchInput)),
        getDocs(customerSearchQuery('email', searchInput)),
        getDocs(customerSearchQuery('mobile', searchInput))
      ]).then((querySnapshots) => {
        // merge all query results into one array
        const users = querySnapshots.reduce((acc, cur) => [
          ...acc, 
          ...cur.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        ], [])
        // filter duplicates
        .filter((user, index, self) =>
          index === self.findIndex((t) => (
            t.id === user.id
          ))
        );
        
        setFilteredUsers(users);
      });

    }, [searchInput]);
 
  return (
    <>
      <AdminNavbar />
      <div className='customerInfo'>
      <TextField 

      className="searchInput" 
      label="User search"
      onChange={(e) => setSearchInput(e.target.value)}
      />
      {(filteredUsers.map((user) => ( 
        <List key={user.id} sx={{  width:'100%',maxWidth: 400, bgcolor: 'background.paper', boxShadow: 2, margin: '0 auto', marginTop:2, alignItems:'center' }}>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={user.firstName + ' ' + user.lastName}  />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <EmailIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={user.email} />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PhoneIphoneIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={user.mobile} />
        </ListItem>
        <Link to={`/edit-user-data/${user.id}`}>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <EditIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary='Edit' />
          </ListItem>
        </Link>
      </List>
      )))}
      </div>
    </>
  );
}